export default __webpack_public_path__ + "static/media/youtube.d139e64c.png";